import React from 'react';
import PackOpening from '../domains/muses/components/PackOpening';

const PackOpeningPage: React.FC = () => {
  return <PackOpening />;
};

export default PackOpeningPage; 